<template id="v-chart">
  <canvas></canvas>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'vChart',
  props: ['data', 'beginAtZero'],
  template: '#v-chart',
  mounted: function() {
    this.setData(this.data)
  },
  watch: {
    data: function(data) {
      if (Object.keys(data).length > 0) {
        this.setData(data)
      }
    },
  },
  methods: {
    setData(data) {
      const el = this.$el.getContext('2d')
      new Chart(el, {
        data: data,
        type: 'bar',
        options: {
          responsive: true,
          legend: {
            position: 'top',
          },
          title: {
            display: true,
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: this.beginAtZero,
              },
            }],
          },
        },
      })
    },
  },
}
</script>
